document.addEventListener('DOMContentLoaded', () => {
    // Modal Logic
    const modal = document.getElementById('applicationModal');
    const formContainer = document.getElementById('modal-form-container');
    const successContainer = document.getElementById('modal-success-container');
    const form = document.getElementById('affiliateForm');

    window.openModal = function () {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    window.closeModal = function () {
        modal.classList.remove('active');
        document.body.style.overflow = '';

        // Reset modal state after animation
        setTimeout(() => {
            formContainer.classList.remove('hidden');
            successContainer.classList.add('hidden');
            form.reset();
        }, 300);
    };

    // Close modal on outside click
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            closeModal();
        }
    });

    // Handle Form Submission
    form.addEventListener('submit', (e) => {
        e.preventDefault();

        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Submitting...';
        submitBtn.disabled = true;

        const scriptURL = 'https://script.google.com/macros/s/AKfycbw5IeHvCeU4kdj5QPXaErpNVPbvtZWe_31dvnymXeq8Ou0Tb8HrXwdGDHF1td_fWLa_/exec';

        // Chuyển FormData sang URLSearchParams để Google Apps Script nhận diện e.parameter tốt hơn
        const formData = new FormData(form);
        const params = new URLSearchParams();
        for (const pair of formData.entries()) {
            params.append(pair[0], pair[1]);
        }

        // Referral tracking: đọc ?ref= từ URL và gửi kèm form
        const urlParams = new URLSearchParams(window.location.search);
        const refCode = urlParams.get('ref');
        if (refCode) {
            params.append('referredBy', refCode);
        }

        // Bước 1: Kiểm tra trùng email/phone trước
        var emailVal = encodeURIComponent(form.querySelector('#email').value.trim());
        var phoneVal = encodeURIComponent(form.querySelector('#phone').value.trim());
        var checkURL = scriptURL + '?action=check&email=' + emailVal + '&phone=' + phoneVal;

        fetch(checkURL)
            .then(response => response.json())
            .then(checkResult => {
                if (checkResult.exists) {
                    // Trùng → hiện thông báo lỗi
                    alert('⚠️ ' + checkResult.message);
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                    return;
                }

                // Bước 2: Không trùng → gửi form
                fetch(scriptURL, {
                    method: 'POST',
                    body: params,
                    mode: 'no-cors'
                })
                    .then(() => {
                        formContainer.classList.add('hidden');
                        successContainer.classList.remove('hidden');

                        // Tạo referral link từ tên
                        var fullName = form.querySelector('#fullName').value || '';
                        var refCode = fullName.replace(/\s+/g, '').substring(0, 5).toUpperCase() + Math.floor(1000 + Math.random() * 9000);
                        var refLink = 'https://yingmart.co/pages/join-as-affiliate?ref=' + refCode;
                        var shareLink = refLink + '&utm_source=affiliate&utm_medium=referral&utm_campaign=invite3';
                        var shareText = 'Join YingMart Affiliate Program and earn premium commissions on luxury jewelry! 💎✧ ';

                        // Hiện link ngắn gọn
                        var refLinkBox = document.getElementById('refLinkBox');
                        if (refLinkBox) refLinkBox.textContent = refLink;

                        // Cập nhật nút share (dùng shareLink có UTM)
                        var wa = document.getElementById('shareWhatsApp');
                        if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(shareText + shareLink);
                        var fb = document.getElementById('shareFacebook');
                        if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareLink);
                        var tg = document.getElementById('shareTelegram');
                        if (tg) tg.href = 'https://t.me/share/url?url=' + encodeURIComponent(shareLink) + '&text=' + encodeURIComponent(shareText);
                        var tw = document.getElementById('shareTwitter');
                        if (tw) tw.href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(shareText + shareLink);

                        window._refLink = refLink; // Copy Link dùng link ngắn
                        submitBtn.textContent = originalText;
                        submitBtn.disabled = false;
                    })
                    .catch(error => {
                        console.error('Error submitting form:', error);
                        alert('Submission failed, please try again.');
                        submitBtn.textContent = originalText;
                        submitBtn.disabled = false;
                    });
            })
            .catch(error => {
                console.error('Error checking duplicate:', error);
                alert('Could not verify registration. Please try again.');
                submitBtn.textContent = originalText;
                submitBtn.disabled = false;
            });
    });

    // Toggle "Previous Brands" field based on affiliate experience
    const hasExperienceSelect = document.getElementById('hasExperience');
    const prevBrandsGroup = document.getElementById('prevBrandsGroup');

    if (hasExperienceSelect && prevBrandsGroup) {
        hasExperienceSelect.addEventListener('change', () => {
            if (hasExperienceSelect.value === 'Yes') {
                prevBrandsGroup.style.display = 'flex';
            } else {
                prevBrandsGroup.style.display = 'none';
                const prevBrandsInput = document.getElementById('previousBrands');
                if (prevBrandsInput) prevBrandsInput.value = '';
            }
        });
    }

    // FAQ Accordion Logic
    const faqQuestions = document.querySelectorAll('.faq-question');
    faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
            const isActive = question.classList.contains('active');

            // Close all
            faqQuestions.forEach(q => {
                q.classList.remove('active');
                q.nextElementSibling.style.maxHeight = null;
            });

            // Open clicked if it wasn't active
            if (!isActive) {
                question.classList.add('active');
                const answer = question.nextElementSibling;
                answer.style.maxHeight = answer.scrollHeight + "px";
            }
        });
    });

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;

            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                e.preventDefault();
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
});

// Copy referral link to clipboard
function copyRefLink() {
    var link = window._refLink || '';
    if (!link) return;
    navigator.clipboard.writeText(link).then(function () {
        var btn = document.getElementById('copyLinkBtn');
        if (btn) {
            btn.textContent = '✅ Copied!';
            setTimeout(function () { btn.textContent = '📋 Copy Link'; }, 2000);
        }
    });
}
